import { CtaButton } from '@/components/astro/cta-button/cta-button';
import * as m from '@/paraglide/messages';
import SpeedControlFeatures from './subcomponents/SpeedControlFeatures';

export function ListenAtSpeed() {
  return (
    <section className='relative mx-auto max-w-[1600px] py-16 md:py-24'>
      <div className='relative mx-auto px-4 lg:px-8'>
        <div className='flex flex-col items-center gap-12 lg:flex-row lg:items-center lg:justify-between'>
          {/* <!-- Speed Control UI --> */}
          <div className='w-full lg:w-3/5 lg:pl-0'>
            <div className='relative mx-auto lg:mx-0'>
              <SpeedControlFeatures />
            </div>
          </div>

          {/* <!-- Content --> */}
          <div className='w-full text-left lg:w-2/5 lg:pr-0 lg:pl-8'>
            <div className='mx-auto max-w-3xl lg:mx-0'>
              {/* <!-- <div className="mb-2 flex justify-center lg:justify-start">
            <IconClock />
          </div> --> */}
              <h2 className='mb-6 text-center text-4xl leading-[110%] font-bold text-black sm:text-5xl lg:text-left lg:text-7xl lg:tracking-[-2.56px]'>
                {m.features_speed_title()}
              </h2>
              <p className='mb-8 text-center text-sm text-neutral-665 sm:text-lg lg:text-left'>
                {m.features_speed_description()}
              </p>
              <div className='flex justify-center lg:justify-start'>
                <CtaButton
                  className='h-10 bg-royal-50 px-8 py-7 text-xl font-light text-white hover:bg-royal-50/90'
                  label={m.common_try_for_free()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
